import React from 'react';
import Table from 'react-bootstrap/Table';

import Display from '../../util/Display';
import Util from '../../util/Util';
import Const from '../../util/Constants';

import DisplayPhone from '../common/DisplayPhone';
import DisplayEmail from '../common/DisplayEmail';

import './LeadPreview.css';

/**
 * this will show lead image and all primary information
 */
class LeadDetails extends React.Component {

  constructor(props) {
    super(props);
    this.setLeadInfo(props);
    this.id = props.lead ? props.lead.id : 0;
    this.HideAllPhone = Util.isAllow(this.props.model.permission, Const.HideAllPhone);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.lead && props.lead.id !== this.id) {
      this.setLeadInfo(props);
    }
  }

  setLeadInfo = props => {
    this.leadScore = 0;
    if (props.lead !== undefined && props.lead.lead_score !== undefined) {
      this.leadScore = props.lead.lead_score;
    }

    const field = 'responsible_person';
    this.owners = Display.FieldValue(props.lead, field, props.model.fields);

    var phones = props.lead ? props.lead.phone : null;
    this.phones = [];
    if (phones && phones !== '' && phones !== '~~') {
      phones = phones.substring(1, phones.length - 1);
      phones = phones.split('~');
      this.phones = phones.map(phone => <DisplayPhone key={`p_d_${phone}`} phone={phone} />);
    }

    var emails = props.lead ? props.lead.email : null;
    this.emails = [];
    if (emails && emails !== '' && emails !== '~~') {
      emails = emails.substring(1, emails.length - 1);
      emails = emails.split('~');
      this.emails = emails.map(email => <DisplayEmail key={`p_e_${email}`} email={email} />);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-4 text-center">
          <img src={process.env.PUBLIC_URL + '/images/user.png'} alt="user" />
          {this.leadScore !== 0 &&
            <span className="userbadge badge badge-danger badge-mini rounded-circle">
              {this.leadScore}
            </span>
          }
        </div>

        <div className="col-md-8 leadsec">
          <Table className="table-sm table-borderless">
            <tbody>
              <tr>
                <th>Lead Owner</th>
                <td>{this.owners ? this.owners : '-'}</td>
              </tr>
              { this.HideAllPhone ? null :
                <tr>
                  <th>Phone</th>
                  <td>{this.phones ? this.phones : '-'}</td>
                </tr>
              }
              <tr>
                <th>Email</th>
                <td>{this.emails ? this.emails : '-'}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export default LeadDetails;